import {useContext} from 'react';

import WebsocketContext from 'contexts/websocket';

export default function useWebsocket() {
  const value = useContext(WebsocketContext);

  return value;
}
